/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Airline,
    AirlineFromJSON,
    AirlineToJSON,
    AirlineListBusinessDataResponse,
    AirlineListBusinessDataResponseFromJSON,
    AirlineListBusinessDataResponseToJSON,
    UploadAirlinesResponse,
    UploadAirlinesResponseFromJSON,
    UploadAirlinesResponseToJSON,
    ValidationErrors,
    ValidationErrorsFromJSON,
    ValidationErrorsToJSON,
} from '../models';

export interface ApiAirlinesApiAirlinesGetByIataCodeIataGetRequest {
    iata: string;
}

export interface ApiAirlinesGetAllAirlinesGetRequest {
    pageNumber?: number;
    pageSize?: number;
    name?: string;
    code?: string;
    icaoCode?: string;
}

export interface ApiAirlinesIdGetRequest {
    id: string;
}

export interface ApiAirlinesPatchRequest {
    airline?: Airline;
}

export interface ApiAirlinesPostRequest {
    airline?: Airline;
}

export interface ApiAirlinesValidatePostRequest {
    airline?: Airline;
}

export interface ApiAirlinesWarningsPostRequest {
    airline?: Airline;
}

/**
 * no description
 */
export class AirlinesApi extends runtime.BaseAPI {

    /**
     */
    async apiAirlinesAllAirlinesGetRaw(): Promise<runtime.ApiResponse<AirlineListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines/AllAirlines`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AirlineListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAirlinesAllAirlinesGet(): Promise<AirlineListBusinessDataResponse> {
        const response = await this.apiAirlinesAllAirlinesGetRaw();
        return await response.value();
    }

    /**
     */
    async apiAirlinesApiAirlinesGetByIataCodeIataGetRaw(requestParameters: ApiAirlinesApiAirlinesGetByIataCodeIataGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.iata === null || requestParameters.iata === undefined) {
            throw new runtime.RequiredError('iata','Required parameter requestParameters.iata was null or undefined when calling apiAirlinesApiAirlinesGetByIataCodeIataGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines/api/Airlines/GetByIataCode/{iata}`.replace(`{${"iata"}}`, encodeURIComponent(String(requestParameters.iata))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAirlinesApiAirlinesGetByIataCodeIataGet(requestParameters: ApiAirlinesApiAirlinesGetByIataCodeIataGetRequest): Promise<void> {
        await this.apiAirlinesApiAirlinesGetByIataCodeIataGetRaw(requestParameters);
    }

    /**
     */
    async apiAirlinesBulkUploadAirlinesPostRaw(): Promise<runtime.ApiResponse<UploadAirlinesResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines/BulkUploadAirlines`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadAirlinesResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAirlinesBulkUploadAirlinesPost(): Promise<UploadAirlinesResponse> {
        const response = await this.apiAirlinesBulkUploadAirlinesPostRaw();
        return await response.value();
    }

    /**
     */
    async apiAirlinesGetAllAirlinesGetRaw(requestParameters: ApiAirlinesGetAllAirlinesGetRequest): Promise<runtime.ApiResponse<AirlineListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.icaoCode !== undefined) {
            queryParameters['icaoCode'] = requestParameters.icaoCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines/GetAllAirlines`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AirlineListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAirlinesGetAllAirlinesGet(requestParameters: ApiAirlinesGetAllAirlinesGetRequest): Promise<AirlineListBusinessDataResponse> {
        const response = await this.apiAirlinesGetAllAirlinesGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAirlinesIdGetRaw(requestParameters: ApiAirlinesIdGetRequest): Promise<runtime.ApiResponse<AirlineListBusinessDataResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiAirlinesIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AirlineListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAirlinesIdGet(requestParameters: ApiAirlinesIdGetRequest): Promise<AirlineListBusinessDataResponse> {
        const response = await this.apiAirlinesIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAirlinesPatchRaw(requestParameters: ApiAirlinesPatchRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AirlineToJSON(requestParameters.airline),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAirlinesPatch(requestParameters: ApiAirlinesPatchRequest): Promise<void> {
        await this.apiAirlinesPatchRaw(requestParameters);
    }

    /**
     */
    async apiAirlinesPostRaw(requestParameters: ApiAirlinesPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AirlineToJSON(requestParameters.airline),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiAirlinesPost(requestParameters: ApiAirlinesPostRequest): Promise<string> {
        const response = await this.apiAirlinesPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAirlinesValidatePostRaw(requestParameters: ApiAirlinesValidatePostRequest): Promise<runtime.ApiResponse<ValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AirlineToJSON(requestParameters.airline),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiAirlinesValidatePost(requestParameters: ApiAirlinesValidatePostRequest): Promise<ValidationErrors> {
        const response = await this.apiAirlinesValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAirlinesWarningsPostRaw(requestParameters: ApiAirlinesWarningsPostRequest): Promise<runtime.ApiResponse<ValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Airlines/Warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AirlineToJSON(requestParameters.airline),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiAirlinesWarningsPost(requestParameters: ApiAirlinesWarningsPostRequest): Promise<ValidationErrors> {
        const response = await this.apiAirlinesWarningsPostRaw(requestParameters);
        return await response.value();
    }

}
